// extracted by mini-css-extract-plugin
export default {"notify-type-choose":"_3in92373tNRY3oku-Ck0Lt","notify-type-choose__radio-box":"_1yJVq-kdk9hyMG3JR8rqhS"};